import React from 'react';
import { X, Trash } from 'lucide-react';
import { useChat } from '../../context/ChatContext';
import { toast } from 'sonner';
import { useNavigate, useParams } from 'react-router-dom';

export default function DeleteChatModal() {
  const { chatId } = useParams();
  const navigate = useNavigate();
  const {
    deleteChatId,
    setDeleteChatId,
    deleteChatById,
    setActiveChatId,
    getChatHistory,
  } = useChat();
  if (!deleteChatId) return null;

  const handleDelete = async () => {
    if (deleteChatId) {
      try {
        await deleteChatById(deleteChatId);
        toast.success('Chat deleted successfully!');
        // Navigate only if the deleted chat was active
        if (chatId === deleteChatId) {
          navigate('/chat');
          setDeleteChatId('');
          setActiveChatId('');
        } else {
          setDeleteChatId(''); // Close modal
        }

        await getChatHistory();
      } catch (error) {
        console.error('Failed to fetch chat history:', error);
        toast.error('Failed to fetch chat history!');
        setDeleteChatId('');
      }
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 py-4 px-10">
      <div className="w-full max-w-md p-6 bg-white shadow-xl rounded-2xl">
        <h2 className="mb-4 text-xl font-semibold text-gray-900">
          Delete chat?
        </h2>
        <div className="mb-6 space-y-2 text-gray-700">
          <p>
            This will delete{' '}
            <strong>entire chat history and can't be undone</strong> .
          </p>
        </div>
        <div className="flex justify-end gap-3">
          <button
            onClick={() => setDeleteChatId('')}
            className="flex items-center gap-2 px-4 py-2 text-gray-700 border rounded-lg hover:text-gray-900 hover:bg-gray-100"
          >
            <X className="size-4" />
            Cancel
          </button>
          <button
            onClick={handleDelete}
            className="flex items-center gap-2 px-4 py-2 text-white bg-red-600 rounded-lg hover:bg-red-700"
          >
            <Trash className="size-4" />
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}
